import React from "react";
import {UrlList} from "../stories/lists/url-list/url-list";
import {SummaryList} from "../stories/lists/summary-list/summary-list";
import styled from "styled-components";


export const Details = ({results, $status, autoContinue}) => {
    let listText,
        listType,
        listItems,
        urlText

    if (results.risks.length === 0) {
        if (results.redirects.length > 0) {
            urlText = 'The link has {count} redirects'
        } else {
            urlText = 'The link has 1 destination'
        }
        if (results.content.length > 0) {
            listText = results.redirects.length > 1
                ? 'These links have the following potential reputation:'
                : 'The link has the following potential reputation:';
            listType = 'reputation'
            listItems = results.content;
        }
    } else {
        if (results.redirects.length > 0) {
            urlText = 'The link has {count} redirects'
        } else {
            urlText = 'The link has 1 destination'
        }
        listText = results.redirects.length > 1
            ? 'These links have the following potential risks:'
            : 'The link has the following potential risks:';
        listType = 'risks'
        listItems = results.risks

    }
    if (results.isSecure === false && results.isFile === true) {
        listType = 'default'
    }
    return (
        <div>
            <ColumnTitle>About this link</ColumnTitle>
            <UrlList expandable={true}
                     urls={results.redirects.length > 0 ? results.redirects : [results.url]} text={urlText}
                     urlLength={100}/>
            {listType !== null &&
                <SummaryList text={listText} items={listItems}
                             type={listType}/>
            }

        </div>
    )
}

const ColumnTitle = styled.h4`
  margin-bottom: 30px;
`
